module.exports = __webpack_public_path__ + "img/ys-djt.2e13235c.png";